import React, { forwardRef } from 'react';
import Text from '@polestar/component-warehouse-react/components/text/Text';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import LetterSpacings from '@polestar/component-warehouse-react/tokens/letter-spacings/LetterSpacings';
export const ParagraphVariantSizes = {
    [Sizes.medium]: {
        fontSize: FontSizes.body,
        lineHeight: LineHeights.small,
        letterSpacing: LetterSpacings.small,
    },
    [Sizes.large]: {
        fontSize: FontSizes.large,
        letterSpacing: LetterSpacings.large,
        lineHeight: LineHeights.large,
    },
};
const Paragraph = forwardRef(({ size = Sizes.medium, ...props }, ref) => {
    return React.createElement(Text, { ref: ref, as: "p", variant: ParagraphVariantSizes[size], ...props });
});
Paragraph.displayName = 'Paragraph';
export default Paragraph;
